// extracted by mini-css-extract-plugin
module.exports = {"container":"PentagonContainer_container__XVXKN","children":"PentagonContainer_children__1W4Jo"};